import React, { type FC } from 'react';

import i18n from '@yandex-int/i18n';
import { wrapInText } from 'client/lib/i18n-utils';
import { routes } from 'client/lib/routes';
import * as keysetAlice from 'i18n/AliceSkillForm';
import * as settingsKeyset from 'i18n/SettingsLabels';

import { Link, QuestionLink } from '../Link/Link';

import styles from './Description.module.scss';

const t = i18n(keysetAlice);
const tSettings = i18n(settingsKeyset);

const StoreLink: React.FC = (props) => <Link to={__appConfig.app.storeUrl} theme="info" target="_blank" {...props} />;

export const SkillNameDescription: FC = () => {
    const wrapStoreLink = wrapInText((s) => <StoreLink>{s}</StoreLink>);
    return <span>{wrapStoreLink(t('description-skill-name-short'))}</span>;
};

const wrapWebmasterLink = wrapInText((s) => (
    <Link to="https://webmaster.yandex.ru/sites/add/" target="_blank" theme="info">
        {s}
    </Link>
));

export const ActivationPhrasesDescription: FC = () => (
    <>
        {t('description-activation')}
        <QuestionLink to={routes.documentation.aliceSkills.generalSettings} />
    </>
);

export const AppMetricaDesctiptionBanner: FC = () => (
    <span>
        {wrapInText((s) => (
            <Link to="https://appmetrica.yandex.ru/docs/" theme="info">
                {s}
            </Link>
        ))(t('app-metrica-description-short'))}
        <QuestionLink to={routes.documentation.aliceSkills.appmetrica} />
    </span>
);

export const StructuredExamplesDescription: FC = () => (
    <>
        {wrapInText(
            (s) => <StoreLink>{s}</StoreLink>,
            (s) => <span>{s}</span>,
        )(t('description-activation-examples'))}
        <QuestionLink to={routes.documentation.aliceSkills.structuredExamples} />
    </>
);

export const StateFlagDescription: FC = () =>
    wrapInText((s) => (
        <Link theme="info" to={routes.documentation.aliceSkills.stateStorage}>
            {s}
        </Link>
    ))(t('storage-description'));

export const BrandVerificationWebsiteDescription: FC = () => (
    <p className={styles.noWidow}>
        {wrapWebmasterLink(tSettings('description-verification'))}
        {'\u00A0'}
        <QuestionLink to={routes.documentation.aliceSkills.publicationSettings} />
    </p>
);

export const RsyFieldDescription: FC = () =>
    wrapInText((s) => (
        <Link to={routes.documentation.aliceSkills.rsy} target="_blank">
            {s}
        </Link>
    ))(t('description-rtb-id'));
